import React, { Component } from "react";
import StyledCheckbox from "../Shared/StyledCheckbox";

class SearchOptions extends Component {
  state = {
    DropDownOpen: false,
  };

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ DropDownOpen: false });
      this.props.onClick && this.props.onClick();
    }
  };

  setWrapperRef = (node) => {
    this.wrapperRef = node;
  };

  handleDropdown = () =>
    this.setState(
      { DropDownOpen: !this.state.DropDownOpen },
      () => this.props.onClick && this.props.onClick(this.state.DropDownOpen)
    );

  handleChecked = (e) => {
    this.props.updateParentState({
      Options: { ...this.props.options, [e.target.name]: e.target.checked },
    });
  };

  render() {
    const { enableDigitalSearch, enablePhysicalSearch } = this.props.options;
    const _ = this.props._;
    return (
      <div
        ref={this.setWrapperRef}
        className={"dropdown portlet-menu d-inline-block "}
      >
        <button
          className={
            "dropdown-toggle portlet-menu-button" +
            (!this.props.noBorder && this.state.DropDownOpen
              ? " omni-brc-international-orange"
              : "")
          }
          type="button"
          aria-haspopup="true"
          aria-expanded={this.state.DropDownOpen}
          onClick={(e) => {
            e.stopPropagation();
            this.handleDropdown();
          }}
        >
          <span
            className={
              this.state.DropDownOpen
                ? " omni-color-international-orange"
                : this.props.iconSwitch
                ? " omni-color-white "
                : ""
            }
          >
            &#8942;
          </span>
        </button>
        <div
          className={
            "dropdown-menu options" + (this.state.DropDownOpen ? " show" : "")
          }
        >
          <div className="option">
            <StyledCheckbox
              name="enableDigitalSearch"
              onChange={this.handleChecked}
              checked={enableDigitalSearch}
            />
            {_.ClientHub.Digital}
          </div>
          <div className="option">
            <StyledCheckbox
              name="enablePhysicalSearch"
              onChange={this.handleChecked}
              checked={enablePhysicalSearch}
            />
            {_.ClientHub.Physical}
          </div>
        </div>
      </div>
    );
  }
}

export default SearchOptions;
